import { ISupportedNonprofits } from '../../interfaces/companyProfile/iSupportedNonprofits';
import { INonprofit } from '../../interfaces/iNonprofit'

export class SupportedNonprofits implements ISupportedNonprofits {
	nextPage: number;
	supportedNonprofits: INonprofit[];

	constructor(supportedNonprofits: ISupportedNonprofits = {} as ISupportedNonprofits) {
		this.nextPage = supportedNonprofits.nextPage;
		this.supportedNonprofits = supportedNonprofits.supportedNonprofits;
	}
}



// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/companyProfile/supprotedNonprofits.ts